import { t } from "@redotech/redo-i18n";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { settingsPagePermission } from "@redotech/redo-merchant-app-common/routing/settings-page-permission";

export const shippingSettingsRoutes: PermissionedRouteObject[] = [
  {
    handle: {
      get breadcrumb() {
        return t("Carriers", {
          context: "merchant settings label for shipping carriers",
        });
      },
      permission: settingsPagePermission("shipping/carriers"),
    },
    path: "carriers",
    lazy: async () => {
      const { CarriersPage: Carriers } =
        await import("@redotech/redo-merchant-fulfillment-app/setting/carrier-accounts/carriers-page");
      return { Component: Carriers };
    },
  },
  {
    handle: {
      get breadcrumb() {
        return t("Freight", {
          context: "merchant settings label for freight shipping",
        });
      },
      permission: settingsPagePermission("shipping/freight"),
    },
    path: "freight",
    lazy: async () => {
      const { FreightPage } =
        await import("../../../../setting/freight/freight-page");
      return { Component: FreightPage };
    },
  },
  {
    handle: {
      get breadcrumb() {
        return t("Fulfillment promise", {
          context:
            "merchant settings label for the shipping fulfillment promise",
        });
      },
      permission: settingsPagePermission("shipping/fulfillment-promise"),
    },
    path: "fulfillment-cutoff",
    lazy: async () => {
      const { FulfillmentCutoffPage } =
        await import("../../../../setting/fulfillment-cutoff/fulfillment-cutoff-page");
      return { Component: FulfillmentCutoffPage };
    },
  },
];
